import { useState } from "react";
import { FormControlLabel, Radio, RadioGroup, Typography } from "@mui/material";
import { Modal } from "../../../common";
import { RecurrenceEditScope } from "../../../../enums";

type RecurrenceScopeDialogProps = {
  open: boolean;
  title: string;
  message: string;
  options: { label: string; value: RecurrenceEditScope }[];
  primaryButtonText: string;
  isSaving?: boolean;
  onClose: () => void;
  onConfirm: (scope: RecurrenceEditScope) => void;
};

export const RecurrenceScopeDialog = ({
  open,
  title,
  message,
  options,
  primaryButtonText,
  isSaving = false,
  onClose,
  onConfirm,
}: RecurrenceScopeDialogProps) => {
  const [scope, setScope] = useState(RecurrenceEditScope.ThisOccurrence);

  return (
    <Modal
      open={open}
      onClose={onClose}
      title={title}
      content={
        <>
          <Typography className="dashboard-helper-text" sx={{ mt: 1 }}>
            {message}
          </Typography>
          <RadioGroup
            value={scope}
            onChange={(event) =>
              setScope(event.target.value as RecurrenceEditScope)
            }
            sx={{ my: 1.5 }}
          >
            {options.map((option) => (
              <FormControlLabel
                key={option.value}
                value={option.value}
                control={<Radio size="small" />}
                label={option.label}
              />
            ))}
          </RadioGroup>
        </>
      }
      primaryButtonText={primaryButtonText}
      secondaryButtonText="Cancel"
      onPrimaryButtonClick={() => onConfirm(scope)}
      onSecondaryButtonClick={onClose}
      disablePrimaryButton={isSaving}
      sx={{
        modal: { width: { xs: "90%", sm: 420 } },
      }}
    />
  );
};
